<app-slide-builder-section-background
  class="slide-builder-section-background"
  [section]="section"
  [isFirstSection]="isFirstSection"
  [isLastSection]="isLastSection"
  [rightColumn]="rightColumn"
  [leftColumn]="leftColumn"
  (mediaRatioChanged)="backgroundMediaRatioChanged($event)">
</app-slide-builder-section-background>

<div
  class="slide-builder-section row"
  [style.aspect-ratio]="aspectRatio"
  [ngClass]="{ 'dark-mode' : section.darkMode, clickable: !!section.link }"
  [extendedRouterLink]="section.link?.uri">
  @switch (section.type) {
    @case (layoutTypes.ONE_COLUMN) {
      <div class="col-12 slide-builder-section-column" [class.last-section-mobile-spacing]="isLastSection">
        <div class="widget-list">
          @for (slide of section.items; track slide) {
            <ng-container *ngTemplateOutlet="slide.isQuestion ? questionTmp : slideTmp; context: { slide: slide, backgroundContext: section }"></ng-container>
          }
        </div>
      </div>
    }
    @case (layoutTypes.TWO_COLUMN) {
      <div class="col-12 row slide-builder-section-column slide-builder-section-column--two-cols">
        <div
          #leftColumn
          class="widget-list"
          [ngClass]="'justify-content-sm-' + (section.alignment || 'start')">
          @for (slide of section.left_columns_items; track slide) {
            <ng-container *ngTemplateOutlet="slide.isQuestion ? questionTmp : slideTmp; context: { slide: slide, backgroundContext: slideBackgroundComponent()?.leftColumnBackground }"></ng-container>
          }
        </div>
        <div
          #rightColumn
          class="widget-list"
          [ngClass]="'justify-content-sm-' + (section.alignment || 'start')">
          @for (slide of section.right_columns_items; track slide) {
            <ng-container *ngTemplateOutlet="slide.isQuestion ? questionTmp : slideTmp; context: { slide: slide, backgroundContext: slideBackgroundComponent()?.rightColumnBackground }"></ng-container>
          }
        </div>
      </div>
    }
  }
</div>

<ng-template #questionTmp let-slide="slide" let-backgroundContext="backgroundContext">
  <app-question-widget
    class="section-widget"
    [isSlideBuilder]="true"
    [data]="slide"
    [(ngModel)]="answer"
    [isHorizontal]="section.type === layoutTypes.TWO_COLUMN"
    [slideBackgroundContext]="backgroundContext"
    (interactionCompleted)="slideInteractionCompleted($event)"
    (ngModelChange)="slideAnswerChanged(slide, $event)">
  </app-question-widget>
</ng-template>

<ng-template #slideTmp let-slide="slide" let-backgroundContext="backgroundContext">
  <app-general-widget
    class="section-widget"
    [ngClass]="slide.bundle"
    [data]="slide"
    [isSlideBuilder]="true"
    [chapterContainerHeight]="chapterContainerHeight"
    [isHorizontal]="section.type === layoutTypes.TWO_COLUMN"
    [parentContainerHeight]="parentContainerHeight || elementRef?.nativeElement?.offsetHeight - 40"
    [slideBackgroundContext]="backgroundContext"
    (videoWatched)="emitVideoWatched(slide)"
    (interactionCompleted)="slideInteractionCompleted($event)"
    [requiredToWatchVideo]="requiredToWatchVideo"
    [requiredToCompleteInteraction]="requiredToCompleteInteraction">
  </app-general-widget>
</ng-template>
